import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type DeleteCampaignResponseType = {};

export const useDeleteCampaign = (
  options?: MutationOptions<
    DeleteCampaignResponseType,
    string[],
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete<
        ApiResponse<DeleteCampaignResponseType>
      >(`/campaign/scheduled/${id}`);

      return data.data;
    },
    ...options,
  });
